/* eslint-disable no-eval */
/* eslint-disable no-extend-native */
/* eslint-disable no-new-wrappers */
/* eslint-disable no-useless-escape */
/* [ Refinancing ] ---------------------------------------------------------- */

export function debt_payments_remaining(principal, annual_rate, compounding_frequency, payment, payment_frequency) {
  var rate = nominal_to_effective(annual_rate, compounding_frequency);
  rate = effective_to_nominal(rate, payment_frequency) / payment_frequency;

  var num = (1 - (principal * rate) / payment);
  if (num <= 0)
    return Infinity;
  return -Math.log(num) / Math.log(1 + rate);
}

export function payments_remaining(principal, nominal_rate, payment, payment_frequency) {
  return debt_payments_remaining(principal, nominal_rate, 2, payment, payment_frequency);
}

export function days_between(original_mortgage_date, refinance_date) {
  // The number of milliseconds in one day
  var one_day = 1000 * 60 * 60 * 24;

  // Convert both dates to milliseconds
  var date1_ms = refinance_date.getTime();
  var date2_ms = original_mortgage_date.getTime();

  // Calculate the difference in milliseconds
  var difference_ms = Math.abs(date1_ms - date2_ms);

  // Convert back to days and return
  return Math.round(difference_ms / one_day);
}

export function term_remaining(original_mortgage_date, refinance_date) {
  // Days between two days / 365.25, rounded to nearest year
  var days = days_between(original_mortgage_date, refinance_date);
  return Math.round(days / 365.25);
}

export function get_months_remaining(original_mortgage_date, refinance_date, original_term_length) {
  // Months remaining in term
  var total_months = original_term_length * 12;
  var months_passed = days_between(original_mortgage_date, refinance_date) / (365.25 / 12);
  var months_remaining = total_months - months_passed;
  return Math.round(months_remaining);
}

export function get_pay_periods(payment_frequency) {
  if (payment_frequency === "monthly") {
    return 12;
  } else if (payment_frequency === "semi_monthly") {
    return 12 * 2;
  } else if (payment_frequency === "weekly") {
    return 52;
  } else if (payment_frequency === "yearly") {
    return 1;
  } else {
    return 52 / 2;
  }
}

export function get_divisor(payment_frequency) {
  if (payment_frequency === "monthly") {
    return 365.25 / 12;
  } else if (payment_frequency === "semi_monthly") {
    return (365.25 / 12) * 2;
  } else if (payment_frequency === "weekly") {
    return 7;
  } else if (payment_frequency === "yearly") {
    return 365.25;
  } else {
    return 14;
  }
}

export function get_i(original_mortgage_rate, payment_frequency) {
  var periods_per_year = get_pay_periods(payment_frequency);
  var effective_rate = nominal_to_effective(original_mortgage_rate, 2);
  var i = effective_to_nominal(effective_rate, periods_per_year);
  return i;
}

/* [ Mortgage principal and payments ] -------------------------------------- */

export function annuity_payment(principal, annual_rate, periods_per_year, num_years) {
  var total_payments = periods_per_year * num_years;
  var periodic_rate = annual_rate / periods_per_year;
  var periodic_payment = principal * (periodic_rate + (periodic_rate / (Math.pow(1 + periodic_rate, total_payments) - 1)));

  return periodic_payment;
}

export function annuity_present_value(payment, annual_rate, periods_per_year, num_years) {
  var total_payments = periods_per_year * num_years;
  var periodic_rate = annual_rate / periods_per_year;
  var present_value = payment * ((1 - (1 / Math.pow(1 + periodic_rate, total_payments))) / periodic_rate);

  return present_value;
}

export function nominal_to_effective(nominal_rate, periods_per_year) {
  var effective_rate = Math.pow(1 + nominal_rate / periods_per_year, periods_per_year) - 1;

  return effective_rate;
}

export function effective_to_nominal(effective_rate, periods_per_year) {
  var nominal_rate = periods_per_year * (Math.pow(effective_rate + 1, 1 / periods_per_year) - 1);

  return nominal_rate;
}

export function can_mortgage_payment(principal, annual_rate, num_years, periods_per_year, divisor) {
  var effective_rate = nominal_to_effective(annual_rate, 2);
  var nominal_rate = effective_to_nominal(effective_rate, periods_per_year);

  var payment = annuity_payment(principal, nominal_rate, periods_per_year, num_years) / divisor;

  return payment;
}

export function can_mortgage_principal_purchase(home_price, downpayment, num_years) {
  var downpayment_percent = null;
  if (downpayment >= 1) {
    downpayment_percent = downpayment / home_price;
  } else if (downpayment > 0) {
    downpayment_percent = downpayment;
    downpayment = home_price * downpayment_percent;
  } else {
    return null;
  }

  if (downpayment_percent.round(4) < 0.05 || (home_price >= 1000000 && downpayment_percent.round(4) < 0.2)) {
    return null;
  }

  var loan_to_value = 1 - downpayment_percent;
  var principal = home_price - downpayment;
  principal = principal + principal * (cmhc_premium(loan_to_value) + cmhc_surcharge(loan_to_value, num_years));

  return principal;
}

export function can_mortgage_payment_purchase(home_price, downpayment, annual_rate, num_years, periods_per_year, divisor) {
  var principal = can_mortgage_principal_purchase(home_price, downpayment, num_years);

  if (!periods_per_year) periods_per_year = 12;
  if (!divisor) divisor = 1;

  var payment = can_mortgage_payment(principal, annual_rate, num_years, periods_per_year, divisor);
  return payment;
}

export function can_mortgage_principal(payment, annual_rate, num_years, periods_per_year, divisor) {
  var effective_rate = nominal_to_effective(annual_rate, 2);
  var nominal_rate = effective_to_nominal(effective_rate, periods_per_year);

  var principal = annuity_present_value(payment * divisor, nominal_rate, periods_per_year, num_years);

  return principal;
}

/* [ CMHC premium calculations ] -------------------------------------------- */

export function cmhc_premium(loan_to_value) {
  if (loan_to_value < 0.0 || loan_to_value.round(4) > 0.95)
    return -1;

  if (loan_to_value.round(4) <= 0.80)
    return 0.0;
  else if (loan_to_value.round(4) <= 0.85)
    return 0.0280;
  else if (loan_to_value.round(4) <= 0.90)
    return 0.0310;
  else if (loan_to_value.round(4) <= 0.95)
    return 0.0400;
}

export function cmhc_surcharge(loan_to_value, num_years) {
  if (loan_to_value < 0.0 || loan_to_value > 1.0 || num_years < 1)
    return -1;

  if (loan_to_value.round(4) <= 0.80) {
    return 0.0;
  } else {
    if (num_years > 30)
      return 0.004;
    else if (num_years > 25)
      return 0.002;
    else
      return 0.0;
  }
}

export function cmhc_rate(loan_to_value, num_years) {
  return cmhc_premium(loan_to_value) + cmhc_surcharge(loan_to_value, num_years);
}

export function cmhc_pst(cmhc_amt, province) {
  var tax_rates = {
    'SK': 0.06,
    'ON': 0.08,
    'QC': 0.09
  };

  if (typeof (tax_rates[province]) === 'undefined') {
    return 0;
  }

  return cmhc_amt * tax_rates[province];
}

/* [ Amortization table display on calc extensions ] ------------------------ */

export function can_amortization_table(principal, annual_rate, num_years, periods_per_year, divisor) {
  if (isNaN(principal) || annual_rate === null || isNaN(num_years) || periods_per_year === null || divisor === null)
    return;

  var periodic_payment = can_mortgage_payment(principal, annual_rate, num_years, periods_per_year, divisor);
  // accelerated
  if (divisor === 2 && periods_per_year === 12) {
    periods_per_year = 26;
  }

  var effective_rate = nominal_to_effective(annual_rate, 2);
  var nominal_rate = effective_to_nominal(effective_rate, periods_per_year);
  var periodic_rate = nominal_rate / periods_per_year;

  var total_periods = num_years * periods_per_year;

  var table = [];

  var balance = principal;
  var annual_payment = 0;
  var annual_interest = 0;
  var annual_principal = 0;

  var done = false;
  for (var i = 1; i <= total_periods && !done; ++i) {
    var interest = balance * periodic_rate;
    var principal1 = periodic_payment - interest;
    var payment = periodic_payment;
    if (principal1 > balance) {
      payment -= (principal1 - balance);
      principal1 = balance;
      done = true;
    }

    balance -= principal1;
    annual_payment += payment;
    annual_interest += interest;
    annual_principal += principal1;

    if (i % periods_per_year === 0 || done) {

      if (i === total_periods && balance < 1)
        balance = 0;

      table.push({
        'payment': annual_payment,
        'principal': annual_principal,
        'interest': annual_interest,
        'balance': balance
      });

      annual_payment = 0;
      annual_interest = 0;
      annual_principal = 0;
    }
  }

  return table;
}

/* [ Land Transfer Tax calculations and tables ] ---------------------------- */

export function provincial_ltt(province, home_price) {
  var functionName = province.toLowerCase() + '_ltt';

  // LTT in QC and NS is always municipal
  if (typeof window[functionName] !== 'function' || province === 'QC' || province === "NS") {
    return 0;
  } else {
    return window[functionName](home_price);
  }
}

export function municipal_ltt(province, city, home_price) {
  if (province === 'ON' && in_toronto(city)) {
    return to_ltt(home_price);
  }
  return 0;
}

var toronto_districts = [
  'toronto', 'east-york', 'north-york', 'york', 'etobicoke', 'scarborough'
];
export function in_toronto(city) {
  for (var i = 0; i < toronto_districts.length; i++) {
    var district = toronto_districts[i]
    if (city === district) return true;
  }

  return false;
}

export function ltt_rebate(province, city, fthb, home_price, pcp) {
  var rebate = 0;

  switch (province) {
    case "ON":
      if (fthb) {
        rebate = on_rebate(home_price);
        if (in_toronto(city)) {
          rebate += to_rebate(home_price);
        }
      }
      break;
    default:
      rebate = 0;
      break;
  }
  return rebate;
}

export function total_ltt(home_price, province, city) {
  var total = provincial_ltt(province, home_price) + municipal_ltt(province, city, home_price) - ltt_rebate(province, city, home_price);
  return total;
}

export function on_ltt(home_price) {

  if (home_price > 2000000)
    return (home_price - 2000000) * 0.025 + 36475;

  else if (home_price > 400000)
    return (home_price - 400000) * 0.02 + 4475;

  else if (home_price > 250000)
    return (home_price - 250000) * 0.015 + 2225;

  else if (home_price > 55000)
    return (home_price - 55000) * 0.01 + 275;

  else
    return home_price * 0.005;
}

export function to_ltt(home_price) {
  return on_ltt(home_price);
}

export function on_rebate(home_price, fthb) {
  if (on_ltt(home_price) > 4000)
    return 4000;

  else
    return on_ltt(home_price);
}

export function to_rebate(home_price) {
  if (to_ltt(home_price) > 4475)
    return 4475;

  else
    return to_ltt(home_price);
}

/* [ Utilities estimates ] -------------------------------------------------- */

export function utilities_estimate(home_price, heating) {
  if (home_price === null)
    return;

  return heating + heating_estimate(home_price);
}

export function heating_estimate(home_price) {
  if (home_price === null)
    return;

  return 0.0025 * home_price / 12;
}

/* [ Useful prototypes & extensions ] --------------------------------------- */

// Number formatting functions
Number.formatFunctions = {
  count: 0
};

// Constants useful for controlling the format of numbers in special cases.
Number.prototype.NaN = 'NaN';
Number.prototype.posInfinity = 'Infinity';
Number.prototype.negInfinity = '-Infinity';

Number.prototype.numberFormat = function (format, context) {
  if (isNaN(this)) {
    return Number.prototype.NaNstring;
  } else if (this === +Infinity) {
    return Number.prototype.posInfinity;
  } else if (this === -Infinity) {
    return Number.prototype.negInfinity;
  } else if (Number.formatFunctions[format] === null) {
    Number.createNewFormat(format);
  }
  return this[Number.formatFunctions[format]](context);
};

Number.createNewFormat = function (format) {
  var funcName = "format" + Number.formatFunctions.count++;
  Number.formatFunctions[format] = funcName;
  var code = "Number.prototype." + funcName + " = function(context){\n";

  // Decide whether the export function is a terminal or a pos/neg/zero function
  var formats = format.split(";");
  switch (formats.length) {
    case 1:
      code += Number.createTerminalFormat(format);
      break;
    case 2:
      code += "return (this < 0) ? this.numberFormat(\"" +
        String.escape(formats[1]) +
        "\", 1) : this.numberFormat(\"" +
        String.escape(formats[0]) +
        "\", 2);";
      break;
    case 3:
      code += "return (this < 0) ? this.numberFormat(\"" +
        String.escape(formats[1]) +
        "\", 1) : ((this === 0) ? this.numberFormat(\"" +
        String.escape(formats[2]) +
        "\", 2) : this.numberFormat(\"" +
        String.escape(formats[0]) +
        "\", 3));";
      break;
    default:
      code += "throw 'Too many semicolons in format string';";
      break;
  }
  eval(code + "}");
};

Number.createTerminalFormat = function (format) {
  // If there is no work to do, just return the literal value
  if (format.length > 0 && format.search(/[0#?]/) === -1) {
    return "return '" + String.escape(format) + "';\n";
  }
  // Negative values are always displayed without a minus sign when section
  // separators are used.
  var code = "var val = (context === null) ? new Number(this) : Math.abs(this);\n";
  var thousands = false;
  var lodp = format;
  var rodp = "";
  var ldigits = 0;
  var rdigits = 0;
  var scidigits = 0;
  var scishowsign = false;
  var sciletter = "";
  var m;
  // Look for (and remove) scientific notation instructions, which can be
  // anywhere
  m = format.match(/\..*(e)([+-]?)(0+)/i);
  if (m) {
    sciletter = m[1];
    scishowsign = (m[2] === "+");
    scidigits = m[3].length;
    format = format.replace(/(e)([+-]?)(0+)/i, "");
  }
  // Split around the decimal point
  m = format.match(/^([^.]*)\.(.*)$/);
  if (m) {
    lodp = m[1].replace(/\./g, "");
    rodp = m[2].replace(/\./g, "");
  }
  // Look for %
  if (format.indexOf('%') >= 0) {
    code += "val *= 100;\n";
  }
  // Look for comma-scaling to the left of the decimal point
  m = lodp.match(/(,+)(?:$|[^0#?,])/);
  if (m) {
    code += "val /= " + Math.pow(1000, m[1].length) + "\n;";
  }
  // Look for comma-separators
  if (lodp.search(/[0#?],[0#?]/) >= 0) {
    thousands = true;
  }
  // Nuke any extraneous commas
  if ((m) || thousands) {
    lodp = lodp.replace(/,/g, "");
  }
  // Figure out how many digits to the l/r of the decimal place
  m = lodp.match(/0[0#?]*/);
  if (m) {
    ldigits = m[0].length;
  }
  m = rodp.match(/[0#?]*/);
  if (m) {
    rdigits = m[0].length;
  }
  // Scientific notation takes precedence over rounding etc
  if (scidigits > 0) {
    code += "var sci = Number.toScientific(val," +
      ldigits + ", " + rdigits + ", " + scidigits + ", " + scishowsign + ");\n" +
      "var arr = [sci.l, sci.r];\n";
  } else {
    // If there is no decimal point, round to nearest integer, AWAY from
    // zero
    if (format.indexOf('.') < 0) {
      code += "val = (val > 0) ? Math.ceil(val) : Math.floor(val);\n";
    }
    // Numbers are rounded to the correct number of digits to the right of
    // the decimal
    code += "var arr = val.round(" + rdigits + ").toFixed(" + rdigits + ").split('.');\n";
    // There are at least "ldigits" digits to the left of the decimal, so
    // add zeros if needed.
    code += "arr[0] = (val < 0 ? '-' : '') + String.leftPad((val < 0 ? arr[0].substring(1) : arr[0]), " +
      ldigits + ", '0');\n";
  }
  // Add thousands separators
  if (thousands) {
    code += "arr[0] = Number.addSeparators(arr[0]);\n";
  }
  // Insert the digits into the formatting string. On the LHS, extra digits
  // are copied
  // into the result. On the RHS, rounding has chopped them off.
  code += "arr[0] = Number.injectIntoFormat(arr[0].reverse(), '" +
    String.escape(lodp.reverse()) + "', true).reverse();\n";
  if (rdigits > 0) {
    code += "arr[1] = Number.injectIntoFormat(arr[1], '" + String.escape(rodp) + "', false);\n";
  }
  if (scidigits > 0) {
    code += "arr[1] = arr[1].replace(/(\\d{" + rdigits + "})/, '$1" + sciletter + "' + sci.s);\n";
  }
  return code + "return arr.join('.');\n";
};

Number.toScientific = function (val, ldigits, rdigits, scidigits, showsign) {
  var result = {
    l: "",
    r: "",
    s: ""
  };
  var ex = "";
  // Make ldigits + rdigits significant figures
  var before = Math.abs(val).toFixed(ldigits + rdigits + 1).trim('0');
  // Move the decimal point to the right of all digits we want to keep,
  // and round the resulting value off
  var after = Math.round(new Number(before.replace(".", "").replace(
    new RegExp("(\\d{" + (ldigits + rdigits) + "})(.*)"), "$1.$2"))).toFixed(0);
  // Place the decimal point in the new string
  if (after.length >= ldigits) {
    after = after.substring(0, ldigits) + "." + after.substring(ldigits);
  } else {
    after += '.';
  }
  // Find how much the decimal point moved. This is #places to LODP in the
  // original
  // number, minus the #places in the new number. There are no left-padded
  // zeroes in
  // the new number, so the calculation for it is simpler than for the old
  // number.
  result.s = (before.indexOf(".") - before.search(/[1-9]/)) - after.indexOf(".");
  // The exponent is off by 1 when it gets moved to the left.
  if (result.s < 0) {
    result.s++;
  }
  // Split the value around the decimal point and pad the parts appropriately.
  result.l = (val < 0 ? '-' : '') + String.leftPad(after.substring(0, after.indexOf(".")), ldigits, "0");
  result.r = after.substring(after.indexOf(".") + 1);
  if (result.s < 0) {
    ex = "-";
  } else if (showsign) {
    ex = "+";
  }
  result.s = ex + String.leftPad(Math.abs(result.s).toFixed(0), scidigits, "0");
  return result;
};

Number.prototype.round = function (decimals) {
  if (decimals > 0) {
    var m = this.toFixed(decimals + 1).match(
      new RegExp("(-?\\d*)\.(\\d{" + decimals + "})(\\d)\\d*$"));
    if (m && m.length) {
      return new Number(m[1] + "." + String.leftPad(Math.round(m[2] + "." + m[3]), decimals, "0"));
    }
  }
  return this;
};

Number.injectIntoFormat = function (val, format, stuffExtras) {
  var i = 0;
  var j = 0;
  var result = "";
  var revneg = val.charAt(val.length - 1) === '-';
  if (revneg) {
    val = val.substring(0, val.length - 1);
  }
  while (i < format.length && j < val.length && format.substring(i).search(/[0#?]/) >= 0) {
    if (format.charAt(i).match(/[0#?]/)) {
      // It's a formatting character; copy the corresponding character
      // in the value to the result
      if (val.charAt(j) !== '-') {
        result += val.charAt(j);
      } else {
        result += "0";
      }
      j++;
    } else {
      result += format.charAt(i);
    }
    ++i;
  }
  if (revneg && j === val.length) {
    result += '-';
  }
  if (j < val.length) {
    if (stuffExtras) {
      result += val.substring(j);
    }
    if (revneg) {
      result += '-';
    }
  }
  if (i < format.length) {
    result += format.substring(i);
  }
  return result.replace(/#/g, "").replace(/\?/g, " ");
};

Number.addSeparators = function (val) {
  return val.reverse().replace(/(\d{3})/g, "$1,").reverse().replace(/^(-)?,/, "$1");
};

if (!String.prototype.reverse) {
  String.prototype.reverse = function () {
    var res = "";
    for (var i = this.length; i > 0; --i) {
      res += this.charAt(i - 1);
    }
    return res;
  };
}

if (!String.prototype.trim) {
  (function () {
    // Make sure we trim BOM and NBSP
    var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    String.prototype.trim = function () {
      return this.replace(rtrim, '');
    };
  })();
}

String.leftPad = function (val, size, ch) {
  var result = new String(val);
  if (ch === null) {
    ch = " ";
  }
  while (result.length < size) {
    result = ch + result;
  }
  return result;
};

String.escape = function (string) {
  return string.replace(/('|\\)/g, "\\$1");
};